import NamedDto from 'modules/base/dto/NamedDto';

export class ProjectEditDto extends NamedDto {
	/**
	 * @typedef {Object} _ProjectEditDtoProps
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ProjectEditDtoProps} ProjectEditDtoProps
	 */
	/**
	 *
	 * @param {ProjectEditDtoProps} props
	 * @returns {ProjectEditDto}
	 */
	setup(props) {
		super.setup(props);
		return this;
	}
}

export default ProjectEditDto;
